
import { useCallback } from 'react';
import { useNavigate } from 'react-router-dom';
import { logger } from '@/services/LoggingService';
import { toast } from 'sonner';
import { VEZGO_RETURN_PATH } from '../constants';

export function useNavigationErrorBoundary() {
  const navigate = useNavigate();

  const handleNavigationError = useCallback((error: any) => {
    logger.error('NavigationErrorBoundary', 'Navigation error occurred', {
      error: error instanceof Error ? error.message : String(error)
    });

    toast.error('An error occurred during navigation. Redirecting you to a safe location.');

    // Clear any problematic navigation data
    sessionStorage.removeItem('vezgo_return_url');
    sessionStorage.removeItem('vezgo_previous_path');

    // Navigate to investments page as fallback
    setTimeout(() => {
      navigate(VEZGO_RETURN_PATH, { replace: true });
    }, 1500);
  }, [navigate]);

  return { handleNavigationError };
}
